import { render, staticRenderFns } from "./renter_detail_base.vue?vue&type=template&id=00159019&scoped=true"
import script from "./renter_detail_base.vue?vue&type=script&lang=js"
export * from "./renter_detail_base.vue?vue&type=script&lang=js"
import style0 from "./renter_detail_base.vue?vue&type=style&index=0&id=00159019&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00159019",
  null
  
)

export default component.exports